<template>
  <ReviewSuccessSheet
    v-if="review && title"
    :review="review"
    :title="title"
    :mode="mode"
    :score-color="scoreColor"
    :image-blobs="imageBlobs"
    @close="emit('close')" />
  <div v-else class="flex justify-center items-center h-64 text-gray-400">
    Loading...
  </div>
</template>

<script setup>
import ReviewSuccessSheet from '@/components/Reviews/ReviewSuccessSheet.vue'

const props = defineProps({
  review: {
    type: Object,
    required: true
  },
  title: {
    type: Object,
    required: true
  },
  mode: {
    type: String,
    default: 'view'
  },
  scoreColor: {
    type: String,
    default: null
  },
  imageBlobs: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close'])
</script>
